import {
  CLEAR_APPLICATIONS,
  GET_APPLICATIONS,
  GET_APPLICATION_BY_ID,
} from "../constants/";

const applicationReducerDefaultState = {
  data: [],
};

const applicationReducer = (state = applicationReducerDefaultState, action) => {
  switch (action.type) {
    case GET_APPLICATIONS:
      return { ...state, data: action.payload}
    case GET_APPLICATION_BY_ID:
      return state.data.filter(
        (item) => action.payload.id === item._id.toString()
      );
    case CLEAR_APPLICATIONS:
      return applicationReducerDefaultState;
    default:
      return state;
  }
};
export default applicationReducer;
